import { PlacementWithLogical, Popover, PopoverContent, PopoverTrigger } from '@chakra-ui/react';
import { Calendar, CalendarTabs } from '@sketchnote/shared-components';
import classNames from 'classnames';
import { format } from 'date-fns';
import * as React from 'react';
import type { OnChangeDateRangeCallback } from 'react-calendar';

interface DateRangePickerProps {
  value: [Date] | [Date, Date] | null;
  onChange: OnChangeDateRangeCallback;
  inputClassName?: string;
  placeholderText?: string;
  dateFormat?: string;
  initialTab?: CalendarTabs;
  readOnly?: boolean;
  minDate?: Date | string;
  maxDate?: Date | string;
  placement?: PlacementWithLogical;
}

export const DateRangePicker = ({
  value,
  onChange,
  inputClassName,
  placeholderText = 'Select dates',
  dateFormat = 'do MMM yyyy',
  initialTab = 'date',
  readOnly = false,
  minDate,
  maxDate,
  placement,
}: DateRangePickerProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const open = () => setIsOpen(!isOpen);
  const close = () => setIsOpen(false);

  const handleDatesForInput = (values) => {
    if (!values) return placeholderText;
    else if (values.length === 1) return `${format(values[0], dateFormat)}`;
    else if (values.length > 1)
      return `${format(values[0], dateFormat)} - ${format(values[1], dateFormat)}`;
    return '';
  };

  const handleDoneClick = () => {
    setIsOpen(false);
  };

  return (
    <Popover isOpen={readOnly ? false : isOpen} onClose={close} onOpen={open} placement={placement}>
      <PopoverTrigger>
        <button
          className={classNames({
            'text-gray-500': !value,
            [inputClassName || '']: !!inputClassName,
          })}
          type="button"
        >
          {handleDatesForInput(value)}
        </button>
      </PopoverTrigger>
      <PopoverContent zIndex={4}>
        <Calendar
          value={value}
          onChange={onChange}
          onDone={handleDoneClick}
          initialTab={initialTab}
          minDate={minDate}
          maxDate={maxDate}
        />
      </PopoverContent>
    </Popover>
  );
};
